import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../Config/config"; // adjust path if needed
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
const WhatsNewEmailEditor = () => {
  const releaseNotesCustomArgs = {
    listernaut_email_type: "release_notes",
  };

  const [platform, setPlatform] = useState(localStorage.getItem("platform") || "Listernaut Explorer");
  const [version, setVersion] = useState(localStorage.getItem("version") || "1.0.0");
  const [releaseDate, setReleaseDate] = useState(
    new Date().toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    })
  );
  const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};
  const [features, setFeatures] = useState(localStorage.getItem("features") || "");
  const [enhancements, setEnhancements] = useState(localStorage.getItem("enhancements") || "");
  const [bugs, setBugs] = useState(localStorage.getItem("bugs") || "");
  const [assets, setAssets] = useState([]);
  useEffect(() => {
    const loadAssets = async () => {
      try {
        const res = await axios.get(`${config.API_BASE_URL}/get-all-assets`);
        if (Array.isArray(res.data.assets)) {
          setAssets(res.data.assets);
        }
      } catch (err) {
        console.error("Failed to load assets:", err);
      }
    };
    loadAssets();
  }, []);
  const insertImageHtml = (url, target) => {
    if (!url) return;
    const imgHtml = `
<table role="presentation" width="100%" style="max-width:400px;margin:0 auto;">
  <tr>
    <td style="text-align:center; margin: 0 auto; mso-table-lspace:0pt; mso-table-rspace:0pt;">
      <img src="${url}" width="400" style="width:100%;height:auto;display:block;margin:0 auto;" />
    </td>
  </tr>
</table>
<p></p>`;

    if (target === "features") setFeatures((prev) => (prev || "") + imgHtml);
    else if (target === "enhancements") setEnhancements((prev) => (prev || "") + imgHtml);
    else if (target === "bugs") setBugs((prev) => (prev || "") + imgHtml);
  };
  const [sending, setSending] = useState(false);
  const [sendResult, setSendResult] = useState(null);
  const [users, setUsers] = useState([]);
  const [lnUsers, setLnUsers] = useState([]);
  const [progress, setProgress] = useState({ sent: 0, total: 0 });
  const [errorLog, setErrorLog] = useState([]);

  const [subject, setSubject] = useState(localStorage.getItem("subject") || "Explorer Release Notes" + ` v${version}`);
  const [logoUrl, setLogoUrl] = useState(localStorage.getItem("logoUrl") || "https://storage.googleapis.com/listalotimages/emailtemplates/logo.png");

  // Persist each value to localStorage on change
  useEffect(() => { localStorage.setItem("platform", platform); }, [platform]);
  useEffect(() => { localStorage.setItem("version", version); }, [version]);
  // useEffect(() => { localStorage.setItem("releaseDate", releaseDate); }, [releaseDate]);
  useEffect(() => { localStorage.setItem("subject", subject); }, [subject]);
  useEffect(() => { localStorage.setItem("features", features); }, [features]);
  useEffect(() => { localStorage.setItem("enhancements", enhancements); }, [enhancements]);
  useEffect(() => { localStorage.setItem("bugs", bugs); }, [bugs]);
  useEffect(() => { localStorage.setItem("logoUrl", logoUrl); }, [logoUrl]);

  useEffect(() => {
    const loadUsers = async () => {
      try {
        const res = await axios.get(`${config.API_BASE_URL}/get-all-users`);
        const arr = Array.isArray(res.data) ? res.data : [];
        setUsers(arr);
      } catch (e) {
        console.error('Failed to load users', e);
      }
    };
    loadUsers();
  }, []);


  useEffect(() => {
    if (!users.length) return;

    const loadLnUsers = async () => {
      try {
        const res = await axios.get("https://listernautapi.azurewebsites.net/api/v2/Listalot/users");
        if (Array.isArray(res.data)) {
          const firebaseEmails = users
            .filter(u => u?.email)
            .map(u => String(u.email).toLowerCase());

          const filtered = res.data.filter(u => {
            const email = u?.email ? String(u.email).toLowerCase() : "";
            return email && !firebaseEmails.includes(email);
          });

          setLnUsers(filtered);
        }
      } catch (e) {
        console.error("Failed to load LN users", e);
      }
    };

    loadLnUsers();
  }, [users]);
  const missingEmailRows = [];

  lnUsers.forEach((u, i) => {
    if (!u.email || u.email.trim() === "") {
      missingEmailRows.push({
        row: i,
        user: u
      });
    }
  });

  console.log("=== Users Missing Email JSON ===");
  console.log(JSON.stringify(missingEmailRows, null, 2));
  const renderList = (html) => (
    <div dangerouslySetInnerHTML={{ __html: html }} />
  );

  // --- Build email-safe HTML (inline styles, no Tailwind) to send via backend ---
  const escapeHtml = (s = "") =>
    String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");

  const buildEmailHtml = (recipientName = "there", recipientEmail = "") => {
    const logo = logoUrl;
    const unsubscribeLink = `https://explorer.listernaut.com/unsubscribe?email=${encodeURIComponent(recipientEmail)}`;
    return `<!DOCTYPE html>
<html lang="en">
  <body style="margin:0; padding:0; background:#f3f5f9; font-family:Arial,Helvetica,sans-serif;">
    <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0">
      <tr>
        <td align="center" style="padding:24px;">
          <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0"
            style="max-width:680px; background:#ffffff; border-radius:16px; overflow:hidden; border:1px solid #e6e8f0;">
            <!-- Header -->
            <tr>
              <td style="background:#333999; padding:20px 24px; text-align:center;">
                <img src="${logo}" alt="Listernaut Logo" style="height:40px; background:#fff;border-radius:6px;" />
                <div style="color:#D9DBFF; font-size:13px; margin-top:8px;">Product Updates &amp; Release Notes</div>
              </td>
            </tr>
            <!-- Body -->
            <tr>
              <td style="padding:28px;">
                <h1 style="margin:0 0 8px 0; font-size:28px; line-height:1.2; color:#1f2430; font-weight:800;">
                  What's New in Listernaut
                </h1>
                <p style="margin:0 0 6px 0; color:#64748b; font-size:13px; font-weight:600;">
                  ${escapeHtml(platform)}
                </p>
                <p style="margin:0 0 16px 0; color:#475569; font-size:14px;">
                  Version <strong>${escapeHtml(version)}</strong> · <strong>${escapeHtml(releaseDate)}</strong>
                </p>
                <p style="color:#374151; line-height:1.6; margin:0 0 20px 0;">
                  Hi <strong>${escapeHtml(
      recipientName
    )}</strong>, we’re constantly working to improve your experience.
                  Here’s a rundown of the latest features, enhancements, and fixes now available in your account.
                </p>

                ${features.trim()
        ? `<h2 style="color:#333999; font-size:18px; margin:0 0 13px 0;">🚀 New Features</h2>${features}`
        : ""
      }
                ${enhancements.trim()
        ? `<h2 style="color:#333999; font-size:18px; margin:21px 0 13px 0;">💎 Enhancements</h2>${enhancements}`
        : ""
      }
                ${bugs.trim()
        ? `<h2 style="color:#333999; font-size:18px; margin:21px 0 13px 0;">🐞 Bug Fixes</h2>${bugs}`
        : ""
      }

                <p style="font-size:20px; line-height:30px; font-weight:700; color:#333999; text-align:center; margin:40px 0 0 0;">
                Faster listings. Smarter profits. Level Up with Listernaut
                </p>
                <p style="text-align:center; margin:20px 0 0 0;">
                  <a href="https://outlook.office.com/bookwithme/user/8db9abf233d84ec3827e4e7798ca1934@listernaut.com/meetingtype/QRbr1Ecan0Gkeo_aLMylPA2?anonymous&ismsaljsauthenabled&ep=mcard" 
                     style="font-size:16px; color:#333999; font-weight:600; text-decoration:none;">
                     📅 Need Help or Want a Personalized Walkthrough?
                  </a>
                </p>
              </td>
            </tr>
            <!-- Footer -->
            <tr>
              <td style="padding:25px 40px; font-size:13px; line-height:20px; color:#888888; text-align:center; background-color:#ecf0f1; border-top:1px solid #dcdcdc; border-radius:0 0 12px 12px;">
                <p style="margin:0 0 10px 0; text-align:center;">
                  <a href="https://beta.listernaut.com/" style="color:#333999; text-decoration:underline; font-weight:600; margin-right:20px;">Enterprise</a>
                  <a href="https://explorer.listernaut.com" style="color:#333999; text-decoration:underline; font-weight:600;">Explorer</a>
                </p>
                <p style="margin:0;">If you have any questions or concerns, please reach out to us at
                  <a href="mailto:info@listernaut.com" style="color:#333999; text-decoration:underline;">info@listernaut.com</a>.
                </p>
                <p style="margin:10px 0 0 0;">&copy; ${new Date().getFullYear()} Listernaut. All rights reserved.</p>
                <p style="margin:5px 0 0 0;">📞 <a href="tel:+13177984459" style="color:#333999; text-decoration:none;">(317) 798-4459</a></p>
                <p style="margin:5px 0 0 0;"><a href="${unsubscribeLink}" style="color:#888888;text-decoration:underline;">Unsubscribe</a>.</p>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </body>
</html>`;
  };
  const sendLnEmail = async () => {
    try {
      setSending(true);
      setSendResult(null);
      setErrorLog([]);

      const recipients = lnUsers.filter(u => u?.email && String(u.email).includes("@"));
      if (!recipients.length) {
        setSendResult({ ok: false, message: "No LN user emails found." });
        setSending(false);
        return;
      }

      setProgress({ sent: 0, total: recipients.length });

      for (let i = 0; i < recipients.length; i++) {
        const u = recipients[i];

        const name = u.userName || "there";
        const html = buildEmailHtml(name, u.email);

        try {
          await axios.post(`${config.API_BASE_URL}/send-email`, {
            to: [u.email],
            subject: subject || `What's New in Listernaut — v${version}`,
            html,
            text:
              `What's New in Listernaut — v${version}\n\n` +
              `Hi ${name},\n` +
              `${platform}\n` +
              `Version: ${version} · ${releaseDate}\n\n` +
              `Features:\n${features}\n\nEnhancements:\n${enhancements}\n\nBug Fixes:\n${bugs}`,
            fromName: "Listernaut",
            customArgs: releaseNotesCustomArgs,
          });
        } catch (err) {
          const msg = err?.response?.data?.error || err?.message || "Failed for LN user";
          setErrorLog(prev => [...prev, { email: u.email, error: msg }]);
        }

        setProgress(prev => ({ sent: prev.sent + 1, total: recipients.length }));
      }

      setSendResult({ ok: true, message: `LN send completed (${recipients.length} users). Check errors below.` });
    } catch (err) {
      const msg = err?.response?.data?.error || err?.message || "LN send failed.";
      setSendResult({ ok: false, message: msg });
    } finally {
      setSending(false);
    }
  };

  const sendTestEmail = async () => {
    const testRecipients = [
      "vrushab1998@gmail.com",
      "mark@listernaut.com",
      "logan@listernaut.com",
      "jeff@listernaut.com",
      "bert@listernaut.com"
    ];
    try {
      setSending(true);
      setSendResult(null);
      const html = buildEmailHtml("there", "test@example.com");
      await axios.post(`${config.API_BASE_URL}/send-email`, {
        to: testRecipients,
        subject: `${version} Test Email`,
        html,
        text:
          `Listernaut Test Email — v${version}\n\n` +
          `${platform}\n` +
          `Version: ${version} · ${releaseDate}\n\n` +
          `Features:\n${features}\n\nEnhancements:\n${enhancements}\n\nBug Fixes:\n${bugs}`,
        fromName: "Listernaut",
        customArgs: releaseNotesCustomArgs,
      });
      setSendResult({ ok: true, message: "Test email sent successfully to test recipients." });
    } catch (err) {
      const msg = err?.response?.data?.error || err?.message || "Failed to send test email.";
      setSendResult({ ok: false, message: msg });
    } finally {
      setSending(false);
    }
  };
  const sendEmail = async () => {
    try {
      setSending(true);
      setSendResult(null);
      setErrorLog([]);

      // Filter users that have a valid email
      const recipients = users.filter(u => u?.email && String(u.email).includes('@'));
      if (!recipients.length) {
        setSendResult({ ok: false, message: 'No users with valid email found.' });
        setSending(false);
        return;
      }

      setProgress({ sent: 0, total: recipients.length });

      for (let i = 0; i < recipients.length; i++) {
        const u = recipients[i];
        const name = u.username || 'there';
        const html = buildEmailHtml(name, u.email);
        try {
          await axios.post(`${config.API_BASE_URL}/send-email`, {
            to: [u.email],
            subject: subject || `What's New in Listernaut — v${version}`,
            html,
            text:
              `What's New in Listernaut — v${version}\n\n` +
              `Hi ${name},\n` +
              `${platform}\n` +
              `Version: ${version} · ${releaseDate}\n\n` +
              `Features:\n${features}\n\nEnhancements:\n${enhancements}\n\nBug Fixes:\n${bugs}`,
            fromName: 'Listernaut',
            customArgs: releaseNotesCustomArgs,
          });
        } catch (err) {
          const msg = err?.response?.data?.error || err?.message || 'Failed for user';
          setErrorLog(prev => [...prev, { email: u.email, error: msg }]);
        }
        setProgress(prev => ({ sent: prev.sent + 1, total: recipients.length }));
      }

      setSendResult({ ok: true, message: `Attempted ${recipients.length} sends. Check errors if any.` });
    } catch (err) {
      console.error(err);
      const msg = err?.response?.data?.error || err?.message || 'Failed to send email.';
      setSendResult({ ok: false, message: msg });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-[#f3f5f9] min-h-screen flex flex-row py-8 px-4 gap-6">
      {/* ================= Editor Inputs ================= */}
      <div className="bg-white w-1/2 p-6 rounded-xl shadow border border-gray-200 overflow-y-auto max-h-[90vh]">
        <h2 className="text-2xl font-bold text-[#333999] mb-4">
          Explorer Release Note
        </h2>

        {/* Version / Date / Name Inputs */}
        <div className="flex flex-col gap-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Platform
            </label>
            <select
              value={platform}
              onChange={(e) => setPlatform(e.target.value)}
              className="w-full border rounded-md p-2 text-sm"
            >
              <option value="Listernaut Enterprise">Listernaut Enterprise</option>
              <option value="Listernaut Explorer">Listernaut Explorer</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Version
            </label>
            <input
              type="text"
              value={version}
              onChange={(e) => setVersion(e.target.value)}
              className="w-full border rounded-md p-2 text-sm"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Release Date
            </label>
            <input
              type="text"
              value={releaseDate}
              onChange={(e) => setReleaseDate(e.target.value)}
              className="w-full border rounded-md p-2 text-sm"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Subject
            </label>
            <input
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="What's New in Listernaut — v1.0.0"
              className="w-full border rounded-md p-2 text-sm"
            />
          </div>
        </div>

        <div className="flex flex-col gap-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Logo URL</label>
            <input
              type="url"
              value={logoUrl}
              onChange={(e) => setLogoUrl(e.target.value)}
              className="w-full border rounded-md p-2 text-sm"
              placeholder="https://.../logo.png"
            />
            <p className="text-xs text-gray-500 mt-1">Use a stable CDN (e.g., GCS, CloudFront). Many email clients block dynamic placeholder hosts.</p>
          </div>
        </div>

        {/* Textareas */}
        <div className="flex flex-col gap-6">
          <div className="mb-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">Insert Image / Asset</label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Target Section</label>
                <select
                  className="w-full border rounded-md p-2 text-sm bg-white"
                  value={localStorage.getItem("whatsNewImageTarget") || "features"}
                  onChange={(e) => localStorage.setItem("whatsNewImageTarget", e.target.value)}
                >
                  <option value="features">New Features</option>
                  <option value="enhancements">Enhancements</option>
                  <option value="bugs">Bug Fixes</option>
                </select>
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Choose Existing Asset</label>
                <select
                  className="w-full border rounded-md p-2 text-sm bg-white"
                  onChange={(e) => {
                    const url = e.target.value;
                    const target = localStorage.getItem("whatsNewImageTarget") || "features";
                    if (url) insertImageHtml(url, target);
                    e.target.value = "";
                  }}
                >
                  <option value="">-- Select an asset --</option>
                  {assets.map((a, idx) => (
                    <option key={idx} value={a.url}>
                      {(a.name || "").replace("assets/", "")}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="mt-3">
              <label className="block text-xs font-medium text-gray-600 mb-1">Upload New Image</label>
              <input
                type="file"
                accept="image/*"
                onChange={async (e) => {
                  const file = e.target.files && e.target.files[0];
                  if (!file) return;

                  const formData = new FormData();
                  formData.append("file", file);

                  try {
                    const res = await axios.post(
                      `${config.API_BASE_URL}/upload-email-image`,
                      formData,
                      { headers: { "Content-Type": "multipart/form-data" } }
                    );
                    const url = res.data?.url;
                    const target = localStorage.getItem("whatsNewImageTarget") || "features";
                    if (url) insertImageHtml(url, target);
                  } catch (err) {
                    console.error("Image upload failed:", err);
                    alert("Image upload failed.");
                  } finally {
                    // allow selecting the same file again
                    e.target.value = "";
                  }
                }}
                className="w-full border rounded-md p-2 text-sm bg-white"
              />
              <p className="text-xs text-gray-500 mt-1">Images are inserted as email-safe HTML and will appear in the selected section.</p>
            </div>
          </div>
          <div>
            <label className="block text-sm font-semibold text-[#333999] mb-1">
              🚀 New Features
            </label>
            <ReactQuill
              value={features}
              modules={quillModules}
              onChange={setFeatures}
              theme="snow"
              className="bg-white"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-[#333999] mb-1">
              💎 Enhancements
            </label>
            <ReactQuill
              value={enhancements}
              modules={quillModules}
              onChange={setEnhancements}
              theme="snow"
              className="bg-white"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-[#333999] mb-1">
              🐞 Bug Fixes
            </label>
            <ReactQuill
              value={bugs}
              modules={quillModules}
              onChange={setBugs}
              theme="snow"
              className="bg-white"
            />
          </div>
        </div>

        {/* Send button + status */}
        <div className="mt-6 flex items-center gap-3">
          <button
            onClick={sendEmail}
            disabled={sending}
            className={`px-4 py-2 rounded-md text-white ${sending ? "bg-gray-400" : "bg-[#333999] hover:opacity-90"
              }`}
          >
            {sending ? "Sending…" : `Send to All Users (${users.filter(u => u?.email).length})`}
          </button>
          <button
            onClick={sendLnEmail}
            disabled={sending}
            className={`px-4 py-2 rounded-md text-white ${sending ? "bg-gray-400" : "bg-blue-600 hover:opacity-90"
              }`}
          >
            {sending ? "Sending…" : `Send to LN Users (${lnUsers.filter(u => u?.email).length})`}
          </button>
          <button
            onClick={sendTestEmail}
            disabled={sending}
            className={`px-4 py-2 rounded-md text-white ${sending ? "bg-gray-400" : "bg-green-600 hover:opacity-90"
              }`}
          >
            {sending ? "Sending…" : `Send Test Email (${version})`}
          </button>
          
          {sendResult && (
            <span
              className={`text-sm ${sendResult.ok ? "text-green-600" : "text-red-600"
                }`}
            >
              {sendResult.message}
            </span>
          )}
          {progress.total > 0 && (
            <span className="text-xs text-gray-600">{progress.sent}/{progress.total} sent</span>
          )}
          {errorLog.length > 0 && (
            <div className="mt-2 text-xs text-red-600 max-w-xl">
              <div className="font-semibold">Errors ({errorLog.length}):</div>
              <ul className="list-disc pl-5">
                {errorLog.slice(0, 10).map((e, idx) => (
                  <li key={idx}>{e.email}: {e.error}</li>
                ))}
              </ul>
              {errorLog.length > 10 && <div>…and {errorLog.length - 10} more</div>}
            </div>
          )}
        </div>
      </div>

      {/* ================= Live Email Preview ================= */}
      <div className="bg-white w-1/2 rounded-2xl overflow-y-auto max-h-[90vh] border border-gray-200 shadow-sm">
        {/* Subject bar */}
        <div className="px-4 py-3 border-b border-gray-200 bg-gray-50 flex items-center justify-between">
          <div className="text-sm text-gray-700 truncate"><span className="font-semibold mr-1">Subject:</span>{subject || `What's New in Listernaut — v${version}`}</div>
          <div className="text-xs text-gray-500">Preview</div>
        </div>
        {/* Header */}
        <div className="bg-[#333999] text-center py-6 px-6">
          <div className="flex flex-col items-center justify-center">
            <img
              src={logoUrl}
              alt="Listernaut Logo"
              className="h-10 mb-2 bg-white p-2 rounded-md"
            />
            <p className="text-[#D9DBFF] text-sm">
              Product Updates &amp; Release Notes
            </p>
          </div>
        </div>

        {/* Body */}
        <div className="p-8">
          <h1 className="text-3xl font-extrabold text-gray-900 mb-2">
            What's New in Listernaut
          </h1>
          <p className="text-sm text-gray-500 mb-1 font-semibold">
            {platform}
          </p>
          <p className="text-sm text-gray-600 mb-6">
            Version <strong>{version}</strong> · <strong>{releaseDate}</strong>
          </p>

          <p className="text-gray-700 leading-relaxed mb-8">
            Hi <strong>there</strong>, we’re constantly working to improve
            your experience. Here’s a rundown of the latest features,
            enhancements, and fixes now available in your account.
          </p>

          {/* New Features */}
          {features.trim() && (
            <section className="mb-14 mt-6">
              <h2 className="text-xl font-bold text-[#333999] mb-3">
                🚀 New Features
              </h2>
              <div className="rich-preview">
                {renderList(features)}
              </div>
            </section>
          )}

          {/* Enhancements */}
          {enhancements.trim() && (
            <section className="mb-14 mt-6">
              <h2 className="text-xl font-bold text-[#333999] mb-3">
                💎 Enhancements
              </h2>
              <div className="rich-preview">
                {renderList(enhancements)}
              </div>
            </section>
          )}

          {/* Bug Fixes */}
          {bugs.trim() && (
            <section className="mb-14 mt-6">
              <h2 className="text-xl font-bold text-[#333999] mb-3">
                🐞 Bug Fixes
              </h2>
              <div className="rich-preview">
                {renderList(bugs)}
              </div>
            </section>
          )}

          {/* Footer Message */}
          <p className="text-center text-[#333999] text-lg font-semibold leading-8 mt-10">
            Faster listings. Smarter profits. Level Up with Listernaut
          </p>
        </div>

        {/* Footer */}
        <div className="bg-[#ecf0f1] text-center text-sm text-gray-600 py-6 border-t border-gray-300 rounded-b-2xl">
          <p className="m-0">
            If you have any questions or concerns, please reach out to us at{" "}
            <a
              href="mailto:info@listernaut.com"
              className="text-[#333999] underline"
            >
              info@listernaut.com
            </a>
            .
          </p>
          <p className="mt-2">
            &copy; {new Date().getFullYear()} Listernaut. All rights reserved.
          </p>
          <p className="mt-2">
            📞 <a href="tel:+13177984459" className="text-[#333999] underline">(317) 798-4459</a>
          </p>

        </div>
      </div>
    </div>
  );
};

export default WhatsNewEmailEditor;
